"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ASNResponse = (function () {
    function ASNResponse(data, countries) {
        this._asn = data.asn;
        this._name = data.name;
        this._country = countries[data.country];
        this._countryCode = data.country;
        this._allocated = data.allocated;
        this._registry = data.registry;
        this._domain = data.domain;
        this._prefixes = data.prefixes;
        this._prefixes6 = data.prefixes6;
        this._type = data.type;
        this._num_ips = data.num_ips;
    }
    Object.defineProperty(ASNResponse.prototype, "asn", {
        get: function () {
            return this._asn;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ASNResponse.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ASNResponse.prototype, "country", {
        get: function () {
            return this._country;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ASNResponse.prototype, "countryCode", {
        get: function () {
            return this._countryCode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ASNResponse.prototype, "allocated", {
        get: function () {
            return this._allocated;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ASNResponse.prototype, "registry", {
        get: function () {
            return this._registry;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ASNResponse.prototype, "domain", {
        get: function () {
            return this._domain;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ASNResponse.prototype, "prefixes", {
        get: function () {
            return this._prefixes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ASNResponse.prototype, "prefixes6", {
        get: function () {
            return this._prefixes6;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ASNResponse.prototype, "type", {
        get: function () {
            return this._type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ASNResponse.prototype, "num_ips", {
        get: function () {
            return this._num_ips;
        },
        enumerable: true,
        configurable: true
    });
    return ASNResponse;
}());
exports.default = ASNResponse;
